import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { getAccountCreationConfig, getNeedUserCodeRule } from "@/service/appList";
import AppDetailSync from "@/views/MGT/AppDetail/AppDetailCom/app-detail-sync.vue";
import { encrypt, decrypt } from "@/libs/rsa";
import { userTree, tagListNoPage } from "@/service/structure";
import { editAccountCreationConfig, syncUsers } from "@/service/appList";
import { highlightHtml } from "@/utils/util";
export default {
  name: "orgTreeModal",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      visible: false,
      step: 1,
      appDetailInfo: {},
      dataTree: [],
      tagTree: [],
      searchKeys: "",
      entityList: [],
      addEntities: [],
      removeEntities: [],
      form: {
        accountCreationRule: "AUTO_NAME",
        accountCodePrefix: "",
        passwordCreationRule: "DOWNSTREAM_DEFAULT",
        defaultPassword: "",
        triggerSync: "T"
      },
      needUserCodeRule: true,
      appDetailSyncKey: 0
    };
  },
  components: {
    AppDetailSync
  },
  methods: {
    onStep(step) {
      this.step = step;
    },
    // PMS/UC 是否进入账号创建规则配置，由 needUserCodeRule 接口控制。
    handlePmsUcFirstStep() {
      if (!this.needUserCodeRule) {
        this.confirm();
        return;
      }
      this.onStep(2);
    },
    onDelete(tag) {
      this.entityList = this.entityList.filter(item => item.key !== tag.key);
      this.addEntities = this.addEntities.filter(item => item.key !== tag.key);
    },
    onCheckChangeOrgTree(selection, entity) {
      let {
        key
      } = entity;
      let data = this.entityList.find(item => item.key === key);
      if (data) {
        this.entityList = this.entityList.filter(item => item.key !== key);
        this.removeEntities.push(entity);
        this.addEntities = this.addEntities.filter(item => item.key !== key);
      } else {
        this.entityList.push({
          ...entity,
          icon: entity.icon
        });
        this.addEntities.push(entity);
        this.removeEntities = this.removeEntities.filter(item => item.key !== key);
      }
    },
    formatDepartData(data) {
      return data.map(item => {
        let {
          children,
          orgId,
          organizationUsers,
          name
        } = item;
        let childrenDept = [];
        let users = this.formatUserData(organizationUsers);
        if (children.length > 0) {
          childrenDept = this.formatDepartData(children);
        }
        return {
          key: orgId,
          name,
          disabled: this.titleTip.selectDeptAble,
          children: [...childrenDept, ...users],
          type: "ORG",
          icon: "md-folder"
        };
      });
    },
    formatUserData(data) {
      return data.map(item => {
        let {
          userId,
          userName
        } = item;
        return {
          key: userId,
          name: userName,
          disabled: this.titleTip.selectUserable,
          children: [],
          type: "USER",
          icon: "md-person"
        };
      });
    },
    formatTree(data) {
      let {
        name,
        unitId,
        department,
        unOrgUsers
      } = data;
      let users = this.formatUserData(unOrgUsers);
      let childrenDept = this.formatDepartData(department);
      return [{
        name,
        key: unitId,
        disabled: this.titleTip.selectUnitAble,
        children: [...childrenDept, ...users],
        expand: true,
        type: "UNIT",
        icon: "md-folder"
      }];
    },
    renderContent(h, {
      data
    }) {
      let sty = {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: 330 - 18 * data.depth + "px"
      };
      let html = highlightHtml(data.name, this.searchKeys);
      return h("div", [h("span", {
        "class": "flex gap-1 items-center"
      }, [h("Icon", {
        "attrs": {
          "size": "18",
          "type": data.icon
        },
        "class": "mr-2 text-[#3D7FFF]"
      }), h("div", {
        "class": "mr-2",
        "style": sty,
        "domProps": {
          "innerHTML": html
        }
      }), data.checked ? h("Icon", {
        "attrs": {
          "size": "18",
          "color": "#3D7FFF",
          "type": "md-checkmark"
        }
      }) : null])]);
    },
    async getOrgTree() {
      let {
        data: {
          result,
          retVal
        }
      } = await userTree();
      if (result === 0) {
        this.dataTree = this.formatTree(retVal);
      }
    },
    async getTagList() {
      const {
        data: {
          result,
          retVal
        }
      } = await tagListNoPage();
      if (result === 0) {
        this.tagTree = retVal.map(item => {
          let {
            tagName,
            tagId
          } = item;
          return {
            name: tagName,
            key: tagId,
            type: "TAG",
            icon: "md-pricetag"
          };
        });
      }
    },
    async open(data, appDetailInfo) {
      await this.getOrgTree();
      await this.getTagList();
      this.clearAll();
      data ? this.entityList = data : null;
      this.appDetailInfo = appDetailInfo;
      this.step = 1;
      this.needUserCodeRule = true;
      // 更新 key 值，强制 AppDetailSync 组件刷新
      this.appDetailSyncKey = Math.random();
      if (this._isPmsUc) {
        await this.getNeedUserCodeRule();
        if (this.needUserCodeRule) {
          this.getInitSync(appDetailInfo);
        }
      }
      this.visible = true;
    },
    getEntities(list, result = []) {
      // 递归查找dataTree中匹配list中key的对象
      const findEntities = (nodes, targetKeys, foundItems) => {
        if (!nodes || !targetKeys || targetKeys.length === 0) return;
        for (let node of nodes) {
          // 如果当前节点的key在目标列表中，则添加到结果中
          if (targetKeys.includes(node.key)) {
            foundItems.push(node);
          }

          // 递归查找子节点
          if (node.children && node.children.length > 0) {
            findEntities(node.children, targetKeys, foundItems);
          }
        }
      };
      findEntities(this.dataTree, list, result);
      return result;
    },
    cancel() {
      this.visible = false;
      this.clearAll();
    },
    async confirm() {
      let {
        name
      } = this.$route;
      let addEntities = this.addEntities;
      let removeEntities = this.removeEntities;
      let entityList = this.entityList;
      let pamamsMap = {
        "app-detail": {
          addEntities,
          removeEntities
        },
        authManager: entityList,
        invite: entityList,
        audit: entityList
      };
      this.$emit("on-update", pamamsMap[name]);
      this.visible = false;
    },
    async confirmSave() {
      this.onSubmitSync();
    },
    /*
     * 同步
     */
    async onSubmitSync() {
      const defaultPassword = this.form.passwordCreationRule === "CUSTOM" ? encrypt(this.form.defaultPassword) : "";
      const params = {
        ...this.form,
        defaultPassword
      };
      let res = await editAccountCreationConfig(this.appDetailInfo.appCode, params);
      if (res.data && res.data.result === 0) {
        this.successApi();
      }
    },
    successApi() {
      this.$Message.success($t("ai8d7e4", "修改成功"));
      let {
        name
      } = this.$route;
      let addEntities = this.addEntities;
      let removeEntities = this.removeEntities;
      let entityList = this.entityList;
      let pamamsMap = {
        "app-detail": {
          addEntities,
          removeEntities
        },
        authManager: entityList,
        invite: entityList,
        audit: entityList
      };
      this.$emit("on-update", pamamsMap[name]);
      this.close();
      this.onsubmitUser();
    },
    close() {
      this.step = 1;
      this.form = {
        accountCreationRule: "AUTO_NAME",
        accountCodePrefix: "",
        passwordCreationRule: "DOWNSTREAM_DEFAULT",
        defaultPassword: ""
      };
      this.clearAll();
      this.visible = false;
    },
    async onsubmitUser() {
      await syncUsers("any");
    },
    async getNeedUserCodeRule() {
      try {
        const {
          data
        } = await getNeedUserCodeRule();
        console.log(data);

        // 接口明确返回 false 时跳过下一步；其他异常场景保持原有下一步逻辑。
        this.needUserCodeRule = (data === null || data === void 0 ? void 0 : data.result) === 0 && typeof data.retVal === "boolean" ? data.retVal : true;
      } catch (error) {
        this.needUserCodeRule = true;
      }
    },
    async getInitSync(appDetailInfo) {
      let res = await getAccountCreationConfig(appDetailInfo.appCode);
      if (res.data && res.data.result == 0) {
        res.data.retVal.defaultPassword = res.data.retVal.defaultPassword.replace("\\n", "\n");
        if (res.data.retVal.accountCreationRule) {
          this.form.accountCreationRule = res.data.retVal.accountCreationRule;
        }
        if (res.data.retVal.passwordCreationRule) {
          this.form.passwordCreationRule = res.data.retVal.passwordCreationRule;
        }
        if (!this._isOperaCloud) {
          this.form.accountCodePrefix = res.data.retVal.accountCodePrefix;
        }
        this.form.defaultPassword = decrypt(res.data.retVal.defaultPassword);
      }
    },
    clearAll() {
      this.searchKeys = "";
      this.entityList = [];
      this.addEntities = [];
      this.removeEntities = [];
      this.form = {
        accountCreationRule: "AUTO_NAME",
        accountCodePrefix: "",
        passwordCreationRule: "DOWNSTREAM_DEFAULT",
        defaultPassword: "",
        triggerSync: "T"
      };
    }
  },
  computed: {
    _isPmsUc() {
      var _this$appDetailInfo;
      const appCode = (_this$appDetailInfo = this.appDetailInfo) === null || _this$appDetailInfo === void 0 ? void 0 : _this$appDetailInfo.appCode;
      return appCode === "UC" || appCode === "PMS" || this._isOperaCloud;
    },
    _isOperaCloud() {
      // return this.detail.appId === "ID_OPERA_CLOUD";
      return false;
    },
    totalText() {
      let length = this.entityList.length;
      return `${$t('cg4u0m4', '已选择(')}${length})`;
    },
    titleTip() {
      let {
        name
      } = this.$route;
      let titleTip = {
        "app-detail": {
          title: $t("y12dzg6", "添加访问主体"),
          tip: $t("j00d9pe", "已选择单位/部门/成员/岗位"),
          showTag: true,
          selectUnitAble: false,
          selectUserable: false
        },
        authManager: {
          title: $t("e7yhal4", "添加成员"),
          tip: $t("c5euoq9", "已选择/部门/成员"),
          showTag: false,
          selectUnitAble: true,
          selectUserable: false
        },
        invite: {
          title: $t("e7yhal4", "添加成员"),
          tip: $t("c5euoq9", "已选择/部门/成员"),
          showTag: false,
          selectUnitAble: true,
          selectUserable: true
        },
        audit: {
          title: $t("e7yhal4", "添加成员"),
          tip: $t("ur2ou25", "已选择成员"),
          showTag: false,
          selectUnitAble: true,
          selectDeptAble: true,
          selectUserable: false
        }
      };
      // 路由返回时组件可能先经历 app-mamage 等非弹窗业务路由，兜底空配置避免渲染读取 undefined。
      return titleTip[name] || {};
    },
    filterTreeDataByKeyword() {
      const isIncludes = (node, keyword) => {
        let {
          children
        } = node;
        if (node.name.includes(keyword)) {
          return true;
        } else if (children && children.length) {
          for (let item of children) {
            let res = isIncludes(item, keyword);
            if (res) {
              return true;
            }
          }
        }
        return false;
      };
      const searchTree = (tree, keyword) => {
        let result = [];
        for (let item of tree) {
          if (item.name.includes(keyword)) {
            item.expand = true;
            result.push(item);
          } else if (item.children && isIncludes(item, keyword)) {
            item.expand = true;
            if (item.children) {
              item.children = searchTree(item.children, keyword);
            }
            result.push(item);
          }
        }
        return result;
      };
      let result = searchTree(JSON.parse(JSON.stringify(this.dataTree)), this.searchKeys);
      return result;
    },
    filterTreeData() {
      let nodelist = this.filterTreeDataByKeyword || [];
      const markChecked = (nodelist, parentNode, index) => {
        return nodelist.map(node => {
          if (node.key && this.entityList.some(entity => entity.key === node.key)) {
            node.checked = true; // 设置 checked 属性为 true
            parentNode ? parentNode.expand = true : null;
          } else {
            node.checked = false;
          }
          node.depth = index;

          // 如果当前节点有子节点，递归处理子节点
          if (node.children && node.children.length > 0) {
            node.children = markChecked(node.children, node, index + 1);
          }
          return node;
        });
      };
      return markChecked(JSON.parse(JSON.stringify(nodelist)), null, 1);
    },
    filterTagData() {
      return this.tagTree.filter(tag => {
        return tag.name.includes(this.searchKeys);
      });
    }
  },
  async mounted() {
    await this.getOrgTree();
    await this.getTagList();
  }
};